import React from 'react'
import { Link } from "react-router-dom";


const HomeBlog = () => {
    return (
        <>

        

            <div className="blog-area py-120" style={{marginTop:"-90px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mx-auto">
                            <div className="site-heading text-center">
                                <span className="site-title-tagline"><i className="far fa-book-open-reader" /> Our Blog</span>
                                <h2 className="site-title">Latest News<span></span></h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-lg-4">
                            <div className="blog-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="blog-date"><i className="fal fa-calendar-alt" /> Fab. 18, 2024</div>
                                <div className="blog-item-img">
                                    <img src="assets/school/Blog_2.webp" alt="Thumb" />
                                </div>
                                <div className="blog-item-info">

                                    <h4 className="blog-title mt-lg-4">
                                        <Link to="/details-blog" style={{textAlign:""}}>A Vibrant Saraswati Puja Celebration at Priyadarshani Convent High School</Link>
                                    </h4>
                                    <Link className="theme-btn" to="/details-blog">Read More<i className="fas fa-arrow-right-long" /></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="blog-item wow fadeInUp" data-wow-delay=".50s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                <div className="blog-date"><i className="fal fa-calendar-alt" /> Jan. 12, 2025</div>
                                <div className="blog-item-img">
                                    <img src="assets/school/Blog_1.webp" alt="Thumb" />
                                </div>
                                <div className="blog-item-info">

                                    <h4 className="blog-title mt-lg-4">
                                        <Link to="/details-blog">Importance of physical education for young children.</Link>
                                    </h4>
                                    <br />
                                    <Link className="theme-btn" to="/details-blog">Read More<i className="fas fa-arrow-right-long" /></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="blog-item wow fadeInUp" data-wow-delay=".75s" style={{ visibility: 'visible', animationDelay: '0.75s', animationName: 'fadeInUp' }}>
                                <div className="blog-date"><i className="fal fa-calendar-alt" /> Jan. 14, 2026</div>
                                <div className="blog-item-img">
                                    <img src="assets/school/Blog_3.webp" alt="Thumb" />
                                </div>
                                <div className="blog-item-info">

                                    <h4 className="blog-title mt-lg-4">
                                        <Link to="/details-blog">A Vibrant Saraswati Puja Celebration at Priyadarshani Convent High School</Link>
                                    </h4>
                                    <Link className="theme-btn" to="/details-blog">Read More<i className="fas fa-arrow-right-long" /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default HomeBlog